import useTenantPicker from "../../core/hooks/useTenantPicker";
import StandardSelect, {
  StandardSelectOption,
} from "@jnctn/design-system/Select/StandardSelect.component";
import Text from "@jnctn/design-system/Text/Text.component";
import useNavigateCallback from "@jnctn/hooks/useNavigateCallback";

export default function TenantPicker({
  label,
  defaultTenant,
  validTenant,
}: {
  label?: string;
  defaultTenant?: string;
  validTenant?: boolean;
}) {
  const onChangeTenantNavigation = useNavigateCallback("/");
  const { tenant, checksums, options, onChangeTenant } = useTenantPicker(
    onChangeTenantNavigation,
    defaultTenant
  );

  return (
    <>
      {tenant ? (
        checksums.length > 1 ? (
          <div className="text-center space-y-3 w-full">
            <Text size="body1" weight="bold">
              {label}
            </Text>
            <div className="flex justify-center">
              <StandardSelect
                value={tenant}
                onChange={onChangeTenant}
                className={validTenant ? "w-64" : "w-4/5"}
                label="tenant picker"
              >
                {options.map(({ key, value }) => {
                  return (
                    <StandardSelectOption key={key} value={key}>
                      {value}
                    </StandardSelectOption>
                  );
                })}
              </StandardSelect>
            </div>
          </div>
        ) : (
          <Text color="primary" size="header1">
            {tenant}
          </Text>
        )
      ) : null}
    </>
  );
}
